import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { addReturnsSettings } from './addReturnsSettings';
import { editReturnsSettings } from './editReturnsSettings';

export const workflows: WorkflowOptions[] = [
  addReturnsSettings,
  editReturnsSettings,
  ...Object.values(generateAssetStatusWorkflow('returnsSettings')),
];

export default workflows;
